import { Tab as MuiTab, Tabs as MuiTabs, styled } from '@mui/material';

import { SyntheticEvent } from 'react';
import { ProjectSettingType } from '../../../types';

const Container = styled('div')``;

const Tabs = styled(MuiTabs)(() => {
  return {};
});

const Tab = styled(MuiTab)(() => {
  return {};
});

const Header = ({
  mode,
  onChange,
}: {
  mode: ProjectSettingType;
  onChange: (mode: ProjectSettingType) => void;
}) => {
  const handleOnChangeTab = (e: SyntheticEvent<Element, Event>, value: any) => {
    onChange(value as ProjectSettingType);
  };

  return (
    <Container>
      <Tabs value={mode} onChange={handleOnChangeTab} centered>
        <Tab
          label="Feature"
          value="feature"
          sx={{ textTransform: 'none', fontWeight: 'bold' }}
        />
        <Tab
          label="General"
          value="general"
          sx={{ textTransform: 'none', fontWeight: 'bold' }}
        />
      </Tabs>
    </Container>
  );
};

export default Header;
